import {AbstractControl, ValidationErrors} from "@angular/forms";

export class CimValidators {
  /*
   * BASIC html checker
   * Just checks whether the control's value is surrounded by tags
   *
   * @param {AbstractControl} control
   * @return {ValidationErrors} {html: true} if the control's value does not match the expected pattern, null otherwise
   */
  static html(control: AbstractControl): ValidationErrors | null {
    const pattern = /^<\/?[a-z][\s\S]*>$/;
    if (control.value && !pattern.test(control.value)) {
      return {html: true};
    }

    return null;
  }
}
